import { render, staticRenderFns } from "./CustomMultiselectGeneral.vue?vue&type=template&id=3a823537"
import script from "./CustomMultiselectGeneral.vue?vue&type=script&lang=js"
export * from "./CustomMultiselectGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports